const features = [
  {
    icon: 'ri-links-line',
    title: '官方入口导航',
    description: '提供 91n.com 唯一官方入口地址，确保您安全、快速地访问平台，避免进入仿冒或钓鱼网站。',
  },
  {
    icon: 'ri-book-open-line',
    title: '使用指南教程',
    description: '涵盖 91n.com 平台各项功能的详细使用教程，从注册登录到高级操作，手把手教您使用。',
  },
  {
    icon: 'ri-question-answer-line',
    title: '常见问题解答',
    description: '汇总 91n.com 用户最常遇到的问题及官方解答，帮助您快速解决使用中的各类疑问。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全防护指南',
    description: '提供全面的账号安全、隐私保护和网络风险防范指南，全方位守护您的平台使用安全。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '平台最新动态',
    description: '及时发布 91n.com 最新公告、版本更新和服务调整信息，让您第一时间掌握平台变化。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心客服支持',
    description: '提供多渠道客服支持服务，快速响应您的各类问题和需求，确保优质的使用体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            91n.com 核心功能全解析
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大核心服务模块，全方位满足您在 91n.com 平台的使用需求
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200 transition-colors group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950 whitespace-nowrap">{feature.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}